export const formatNumber = (value: number) => {
  const numberFormatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
  });
  return numberFormatter.format(value);
};

export const formatNumberWithSymbol = (
  value: number,
  currency?: "USD" | "NGN"
) => {
  const numberFormatter = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: currency || "NGN",
    currencyDisplay: "symbol",
    maximumSignificantDigits: 3,
  });
  return `${numberFormatter.format(value)}`;
};

export const graphFormatter = (value: number) => {
  const numberFormatter = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    currencyDisplay: "symbol",
    notation: "compact",
    compactDisplay: "short",
    maximumSignificantDigits: 3,
  });
  return `${numberFormatter.format(value)}`;
};

export const capitalize = (val: string) => {
  if (!val) return "";

  return val[0].toUpperCase().concat(val.slice(1));
};
